<div class="status-block" [ngStyle]="{'background-color': backgroundColor}">
    {{ status | translate | titlecase}}
</div>